export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const ENV_CHANGE = "ENV_CHANGE";
export const NETWORK_ERROR_OCCURRED = "NETWORK_ERROR_OCCURRED";
export const RESET_NETWORK_ERROR = "RESET_NETWORK_ERROR";